import request from '../../utils/request';
export default {
  async getPermissionMenu() {
    return request.get('/api/v2/apps/system/authorization/get_my_menu_key');
  },
  async getUserPermission() {
    return request.get('/api/v2/apps/system/authorization/get_my_perm');
  },
};
